'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;
/* injects from baggage-loader */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _measureText2 = require('components/Projects/utils/measureText');

var _measureText3 = _interopRequireDefault(_measureText2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultilineText = (_temp = _class = function (_Component) {
  _inherits(MultilineText, _Component);

  function MultilineText() {
    _classCallCheck(this, MultilineText);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MultilineText).apply(this, arguments));
  }

  _createClass(MultilineText, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var text = _props.text;
      var color = _props.color;
      var maxWidth = _props.maxWidth;
      var fontFamily = _props.fontFamily;
      var fontSize = _props.fontSize;
      var lineHeight = _props.lineHeight;

      var _measureText = (0, _measureText3.default)({ text: text, maxWidth: maxWidth, fontFamily: fontFamily, fontSize: fontSize, lineHeight: lineHeight });

      var lines = _measureText.lines;


      return _react2.default.createElement(
        'text',
        { y: 0, fontFamily: fontFamily, fontSize: fontSize },
        lines.map(function (line, index) {
          return _react2.default.createElement(
            'tspan',
            {
              fill: color, key: index, x: 0,
              dy: index > 0 ? lineHeight : fontSize - 0.5
            },
            line.text
          );
        })
      );
    }
  }]);

  return MultilineText;
}(_react.Component), _class.propTypes = {
  text: _react.PropTypes.string.isRequired,

  color: _react.PropTypes.string,
  maxWidth: _react.PropTypes.number,
  fontFamily: _react.PropTypes.string,
  fontSize: _react.PropTypes.number,
  lineHeight: _react.PropTypes.number
}, _class.defaultProps = {
  color: 'black',
  maxWidth: +Infinity,
  fontFamily: 'sans-serif',
  fontSize: 14,
  lineHeight: 14 * 1.3
}, _temp);
exports.default = MultilineText;


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/StaticProjectView/utils/MultilineText.js
// module id = 612
// module chunks = 1